"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLogClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
class EventLogClient extends base_client_1.ApiBasicAuthClient {
    static handleEventLogError(name, err, logData) {
        const ctx = Object.assign({ name }, logData);
        if (!err.response) {
            commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err }));
            throw new errors_1.DeliverrError({
                code: errors_1.ApiError.UNKNOWN_ERROR,
                functionName: name,
                payload: err,
            });
        }
        if (err.response && err.response.status !== undefined && err.response.status === 504) {
            const networkError = new errors_1.DeliverrError({
                code: errors_1.ApiError.NETWORK_ERROR,
                functionName: name,
            });
            commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), { err: networkError }));
            throw networkError;
        }
        commons_logs_1.log.error(Object.assign(Object.assign({}, ctx), err.response.data));
        throw new errors_1.DeliverrError({
            code: err.response.data ? err.response.data.code : errors_1.ApiError.UNKNOWN_ERROR,
            functionName: name,
            payload: err.response.data,
        });
    }
    constructor(config) {
        const { authEngine } = config;
        const clientConfig = Object.assign(Object.assign({}, config), { baseURL: `${process.env.EVENT_LOG_SERVICE_URL}/v1`, authEngine });
        if (authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            clientConfig.tokenRefreshFn = new client_auth_1.OAuthClientTokenBuilder(clientConfig).getTokenFn();
        }
        super(clientConfig);
    }
    async upsertEventLog(deliverrEventLog) {
        try {
            return await this.post(`/event/`, deliverrEventLog);
        }
        catch (error) {
            EventLogClient.handleEventLogError("upsertEventLog", error);
        }
    }
    async getEventLogsByEntitySellerIdAndAttributes(entity, sellerId, queryAttributes) {
        try {
            return await this.get(`/event/${entity}/${sellerId}/`, queryAttributes);
        }
        catch (error) {
            EventLogClient.handleEventLogError("getEventLogsByEntitySellerIdAndAttributes", error);
        }
    }
}
exports.EventLogClient = EventLogClient;
//# sourceMappingURL=EventLogClient.js.map